import { useSelector } from 'react-redux';
import { selectors as virtualCardSelectors } from '@ott/shared-virtual-card-logic';
import { useEffect, useState } from 'react';

const usePaymentCheckState = () => {
  const { data: paymentCheckData } = useSelector(virtualCardSelectors.getPaymentCheck);

  const [paymentCheckDataState, setPaymentCheckDataState] = useState(paymentCheckData);

  useEffect(() => {
    if (paymentCheckData) {
      setPaymentCheckDataState(paymentCheckData);
    }
  }, [paymentCheckData]);

  return paymentCheckDataState;
};

export default usePaymentCheckState;
